import gsap from 'gsap';
import $ from '../core/Dom';
import Viewport from '../core/Viewport';

export default el => {
    const $el = $(el);

    const bar = $el.find('[data-scroll-indicator]').get(0);
    const article = el.closest('article');

    // Smoothed setter — see init()
    let setScaleX = null;

    /**
     * Reading progress through the article: 0 when scrolled to the very top,
     * 1 when the article's bottom edge meets the bottom of the viewport.
     */
    const getProgress = () => {
        if (!article) {
            return 0;
        }

        const { bottom } = article.getBoundingClientRect();
        const scrollTop = Viewport.scrollTop;

        // Scroll position at which the article's bottom hits the viewport bottom
        const end = (bottom + scrollTop) - Viewport.height;

        // Article fits within the viewport — its bottom is already visible
        if (end <= 0) {
            return 1;
        }

        return gsap.utils.clamp(0, 1, scrollTop / end);
    };

    const onScroll = () => {
        setScaleX(getProgress());
    };

    const init = () => {
        if (!bar || !article) {
            return;
        }

        // quickTo gives us a smoothed setter: each scroll retargets the same
        // short tween, so the bar trails the scroll position by a hair instead
        // of snapping to it — that's the "small delay" feel.
        setScaleX = gsap.quickTo(bar, 'scaleX', { duration: 0.4, ease: 'power3' });

        Viewport.on('scroll', onScroll);
        Viewport.on('resize', onScroll);

        // Set the initial position
        onScroll();
    };

    const destroy = () => {
        Viewport.off('scroll', onScroll);
        Viewport.off('resize', onScroll);

        if (bar) {
            gsap.killTweensOf(bar);
        }
    };

    return {
        init,
        destroy
    };
};
